import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { useFormik } from 'formik';
import { memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormSelectField from 'components/ui/form/FormSelectField';
import FormSwitchField from 'components/ui/form/FormSwitchField';
import FormNumberField from 'components/ui/form/FormNumberField';

import FormTextField from 'components/ui/form/FormTextField';
import useFormSubmit from 'hooks/useFormSubmit';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(3, { label: 'block.addModal.validation.nameMin', value: 3 })
    .required('block.addModal.validation.name'),
  objects_id: yup.number().required('block.addModal.validation.objectId'),
  month: yup.number().required('block.addModal.validation.objectId'),
});

const BlockAddModal = (props) => {
  const { open, setOpen, setRefetch, data, setData } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();

  const formik = useFormik({
    initialValues: {
      name: '',
      objects_id: '',
      month: '',
      is_sale: '0',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const type = data?.id ? 'put' : 'post';

      submit(
        { type, contentType: 'simple' },
        values,
        '/admin/block',
        values?.name,
        data?.id,
        false,
        handleRefetch
      );
    },
  });

  useEffect(() => {
    if (data) {
      formik.setValues({
        name: data.name,
        objects_id: data.objects_id,
        month: data.month,
        is_sale: data.is_sale,
      });
    }
  }, [data]);

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
    setData({});
  };
  const handleRefetch = () => {
    handleClose();
    setRefetch(true);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      PaperProps={{
        className: '!base-border !shadow-md',
      }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-gray-100 !text-center !mb-2'
      >
        <span>
          {data?.id ? t('block.addModal.editTitle') : t('block.addModal.title')}
        </span>
      </DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormTextField
                delay={0.1}
                label={t('common.fields.blockName')}
                fieldName='name'
                formik={formik}
              />
            </Grid>

            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSelectField
                delay={0.1}
                fieldName='objects_id'
                label={t('common.fields.objectName')}
                formik={formik}
                path={'/dictionary/objects2'}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormNumberField
                delay={0.1}
                label={t('common.fields.month')}
                fieldName='month'
                formik={formik}
              />
            </Grid>
            <Grid item={true} lg={6} sm={6} xs={12}>
              <FormSwitchField
                delay={0.1}
                label={t('boss.residentialComplex.onSale')}
                fieldName='is_sale'
                formik={formik}
                options={[
                  {
                    value: '1',
                    checked: true,
                  },
                  {
                    value: '0',
                    checked: false,
                  },
                ]}
              />
            </Grid>
            <Grid item={true} sm={12} xs={12}>
              <FormActionButtons
                delay={0.3}
                isSubmitting={isSubmitting}
                formType='dialog'
                setOpen={setOpen}
                reset={formik.resetForm}
              />
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default memo(BlockAddModal);
